module.exports = __webpack_public_path__ + "img/DSC00375.fa5d6e38.JPG";